export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_05.a416adbc.jpg";